import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import axios from 'axios';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL_PROD;
axios.defaults.timeout = process.env.REACT_APP_REQ_TIMEOUT;

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
      <BrowserRouter>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </BrowserRouter>
    </RecoilRoot>
  </QueryClientProvider>,
  document.getElementById('root')
);
